import React from 'react';
import {
  useQuery,
} from 'react-query';
import {
  DataGrid,
  GridColDef,
  GridPageChangeParams,
  GridSortModel,
  GridSortModelParams,
} from '@material-ui/data-grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import RecRegistryDay from '../_api/data/RecRegistryDay';
import { Paginated } from '../_api/data/pagination';
import { useEnergyApi } from '../_api/EnergyApiContext';

import { useForm } from 'react-hook-form';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 100 },
  { field: 'imported', headerName: 'Imported', width: 100 },
];

const RecRegistryDays: React.FC = (): React.ReactElement => {
  return (
    <></>
  )
}

export default RecRegistryDays;
